export function startCommercialSession(ids,now=new Date()) {
 return {id:crypto.randomUUID(),ids:[...new Set(ids)],completed:[],paused:false,startedAt:now.toISOString()};
}
export function advanceCommercialSession(session,clientId,eligibleIds){
 if(!session||session.paused)return {session,nextId:null};
 const completed=[...new Set([...session.completed,clientId])],eligible=new Set(eligibleIds);
 const nextId=session.ids.find(id=>eligible.has(id)&&!completed.includes(id))||null;
 return {session:nextId?{...session,completed}:null,nextId};
}
